import Hl7Integrator from "../";

const routes = [
    { name: "Hl7Integrator", path: "/hl7integrator", component: Hl7Integrator.Hl7IntegratorHome, meta: { title: "HL7 Integrator - Home" } },
    { name: "Hl7IntegratorServer", path: "/hl7integratorserver", component: Hl7Integrator.Hl7IntegratorServer, meta: { title: "HL7 Integrator Server" } },
    { name: "Hl7IntegratorClient", path: "/hl7integratorclient", component: Hl7Integrator.Hl7IntegratorClient, meta: { title: "HL7 Integrator Client" } },
];
export default routes;
